import { Skeleton } from '@shared/components/shadcn';

const DEFAULT_SKELETON_COUNT = 6;

type TransactionsLoadingSkeletonProps = {
  skeletonCount?: number;
  title?: string;
};

function TransactionsLoadingSkeleton({ skeletonCount = DEFAULT_SKELETON_COUNT, title }: TransactionsLoadingSkeletonProps) {
  return (
    <>
      {title && <p className="paragraph-explanatory-strong">{title}</p>}
      <div className="flex flex-col gap-6" data-testid="transactions-loading-skeleton">
        {Array.from({ length: skeletonCount }).map((_, i) => (
          <div key={i} className="flex flex-col gap-3">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-12.5 w-full" />
          </div>
        ))}
      </div>
    </>
  );
}

export { TransactionsLoadingSkeleton };
